import type { SiteData, BracketData } from "../types";
import { flipArray, itemLast } from "./utils";

function setSeeds16(
  siteData: SiteData,
  brackets: BracketData,
  type: "winners" | "losers",
): SiteData {
  let seedCount = 1;
  const arr = brackets[type];
  for (let x = 0; x < arr.length; x += 2) {
    const songValues = [arr[x]!, arr[x + 1]!];
    siteData.bracketsModeSettings.gameSeedSetup.activeSeeds[
      "seed" + seedCount
    ] = songValues;
    seedCount += 1;
  }
  siteData.bracketsModeSettings.current2Seeds =
    siteData.bracketsModeSettings.gameSeedSetup.activeSeeds[
      "seed" + siteData.bracketsModeSettings.currentSeed
    ]!;
  return siteData;
}

export interface BracketScenarioResult {
  siteData: SiteData;
  brackets: BracketData;
  isFinal: boolean;
}

export function bracketScenario16(
  inputSiteData: SiteData,
  inputBrackets: BracketData,
  winner: number,
  loser: number,
): BracketScenarioResult {
  const siteData = structuredClone(inputSiteData);
  const brackets = structuredClone(inputBrackets);

  const { currentSeed, gameResults, currentRound } =
    siteData.bracketsModeSettings;
  const winnersRoundsSet1 = [1, 2, 3, 4, 5, 6, 7, 8];
  const losersRoundsSet1 = [9, 10, 11, 12];
  const winnersRoundSet2 = [13, 14, 15, 16];
  const losersRoundsSet2 = [17, 18, 19, 20, 21, 22];
  const winnersRoundSet3 = [23, 24];
  const losersRoundsSet3 = [25, 26, 27];
  const winnersRoundSet4 = [28];

  delete siteData.bracketsModeSettings.gameSeedSetup.activeSeeds[
    "seed" + currentSeed
  ];

  // 1-8 (Winners)
  if (winnersRoundsSet1.includes(currentRound)) {
    brackets.winners.push(winner);
    brackets.losers.push(loser);
    if (currentRound === itemLast(winnersRoundsSet1, 1)) {
      siteData.bracketsModeSettings.currentSeed = 1;
      setSeeds16(siteData, brackets, "losers");
    } else {
      siteData.bracketsModeSettings.currentSeed += 1;
      siteData.bracketsModeSettings.current2Seeds =
        siteData.bracketsModeSettings.gameSeedSetup.activeSeeds[
          "seed" + (currentSeed + 1)
        ]!;
    }
  }

  // 9-12 (Losers)
  if (losersRoundsSet1.includes(currentRound)) {
    gameResults.push(loser);
    const indexOfLoser = brackets.losers.indexOf(loser);
    brackets.losers.splice(indexOfLoser, 1, -1);
    if (currentRound === itemLast(losersRoundsSet1, 1)) {
      siteData.bracketsModeSettings.currentSeed = 1;
      setSeeds16(siteData, brackets, "winners");
      brackets.losers = flipArray(brackets.losers);
    } else {
      siteData.bracketsModeSettings.currentSeed += 1;
      siteData.bracketsModeSettings.current2Seeds =
        siteData.bracketsModeSettings.gameSeedSetup.activeSeeds[
          "seed" + (currentSeed + 1)
        ]!;
    }
    if (!brackets.losers.includes(winner)) {
      brackets.losers.push(winner);
    }
  }

  // 13-16 (Winners)
  if (winnersRoundSet2.includes(currentRound)) {
    if (brackets.winners.includes(loser)) {
      const loserIndex = brackets.winners.indexOf(loser);
      brackets.winners.splice(loserIndex, 1);
    }
    const negativeValue = brackets.losers.indexOf(-1);
    brackets.losers.splice(negativeValue, 1, loser);
    if (currentRound === itemLast(winnersRoundSet2, 1)) {
      siteData.bracketsModeSettings.currentSeed = 1;
      setSeeds16(siteData, brackets, "losers");
    } else {
      siteData.bracketsModeSettings.currentSeed += 1;
      siteData.bracketsModeSettings.current2Seeds =
        siteData.bracketsModeSettings.gameSeedSetup.activeSeeds[
          "seed" + (currentSeed + 1)
        ]!;
    }
  }

  // 17-22 (Losers)
  if (losersRoundsSet2.includes(currentRound)) {
    gameResults.push(loser);
    const indexOfLoser = brackets.losers.indexOf(loser);
    if (
      currentRound === itemLast(losersRoundsSet2, 1) ||
      currentRound === itemLast(losersRoundsSet2, 2)
    ) {
      brackets.losers.splice(indexOfLoser, 1, -1);
    } else {
      brackets.losers.splice(indexOfLoser, 1);
    }
    if (currentRound === itemLast(losersRoundsSet2, 3)) {
      siteData.bracketsModeSettings.currentSeed = 1;
      setSeeds16(siteData, brackets, "losers");
    }
    if (currentRound === itemLast(losersRoundsSet2, 1)) {
      siteData.bracketsModeSettings.currentSeed = 1;
      setSeeds16(siteData, brackets, "winners");
      brackets.losers = flipArray(brackets.losers);
    } else if (currentRound !== itemLast(losersRoundsSet2, 3)) {
      siteData.bracketsModeSettings.currentSeed += 1;
      siteData.bracketsModeSettings.current2Seeds =
        siteData.bracketsModeSettings.gameSeedSetup.activeSeeds[
          "seed" + (currentSeed + 1)
        ]!;
    }
    if (!brackets.losers.includes(winner)) {
      brackets.losers.push(winner);
    }
  }

  // 23-24 (Winners)
  if (winnersRoundSet3.includes(currentRound)) {
    if (brackets.winners.includes(loser)) {
      const loserIndex = brackets.winners.indexOf(loser);
      brackets.winners.splice(loserIndex, 1);
    }
    const negativeValue = brackets.losers.indexOf(-1);
    brackets.losers.splice(negativeValue, 1, loser);
    if (currentRound === itemLast(winnersRoundSet3, 1)) {
      siteData.bracketsModeSettings.currentSeed = 1;
      setSeeds16(siteData, brackets, "losers");
    } else {
      siteData.bracketsModeSettings.currentSeed += 1;
      siteData.bracketsModeSettings.current2Seeds =
        siteData.bracketsModeSettings.gameSeedSetup.activeSeeds[
          "seed" + (currentSeed + 1)
        ]!;
    }
  }

  // 25-27 (Losers)
  if (losersRoundsSet3.includes(currentRound)) {
    gameResults.push(loser);
    const indexOfLoser = brackets.losers.indexOf(loser);
    if (currentRound !== itemLast(losersRoundsSet3, 1)) {
      brackets.losers.splice(indexOfLoser, 1);
    }
    if (currentRound === itemLast(losersRoundsSet3, 2)) {
      siteData.bracketsModeSettings.currentSeed = 1;
      setSeeds16(siteData, brackets, "losers");
    }
    if (currentRound === itemLast(losersRoundsSet3, 1)) {
      brackets.losers.splice(indexOfLoser, 1, -1);
      siteData.bracketsModeSettings.currentSeed = 1;
      setSeeds16(siteData, brackets, "winners");
    } else if (currentRound !== itemLast(losersRoundsSet3, 2)) {
      siteData.bracketsModeSettings.currentSeed += 1;
      siteData.bracketsModeSettings.current2Seeds =
        siteData.bracketsModeSettings.gameSeedSetup.activeSeeds[
          "seed" + (currentSeed + 1)
        ]!;
    }
    if (!brackets.losers.includes(winner)) {
      brackets.losers.push(winner);
    }
  }

  // 28 (Winners)
  if (winnersRoundSet4.includes(currentRound)) {
    if (brackets.winners.includes(loser)) {
      const loserIndex = brackets.winners.indexOf(loser);
      brackets.winners.splice(loserIndex, 1);
    }
    const negativeValue = brackets.losers.indexOf(-1);
    brackets.losers.splice(negativeValue, 1, loser);
    siteData.bracketsModeSettings.currentSeed = 1;
    setSeeds16(siteData, brackets, "losers");
  }

  // 29 (Losers)
  if (currentRound === 29) {
    gameResults.push(loser);
    brackets.losers = [];
    brackets.winners.push(winner);
    siteData.bracketsModeSettings.currentSeed = 1;
    setSeeds16(siteData, brackets, "winners");
  }

  // 30 (Winners) — Final round
  if (currentRound === 30) {
    return { siteData, brackets, isFinal: true };
  }

  siteData.bracketsModeSettings.currentRound += 1;
  return { siteData, brackets, isFinal: false };
}
